// extracted by mini-css-extract-plugin
export default {"container":"i6xLc","text":"YGulH","skeleton-progress":"YbddE"};